import { useEffect } from "react";
import { notification } from "antd";
import { connect, useSelector } from "react-redux";

const ErrorToast = () => {
  const error = useSelector((state) => state.auth.error);
  // Check if error and error.isError exist
  useEffect(() => {
    if (error) {
      notification.open({
        message: "Error",
        description: error.message
          ? error.message
          : "There has been an error, please try again", // Assuming your error object has a 'message' property
        duration: 5, // Duration in seconds
      });
    }
  }, [error]);

  return null; // No error or no need to render anything
};

const mapStateToProps = (state) => {
  return {
    error: state.auth.error, // Assuming you have error stored in your Redux state
  };
};

export default connect(mapStateToProps)(ErrorToast);
